var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table rounded-12"},[_vm._m(0),_c('v-data-table',{staticClass:"elevation-0 rounded-12",attrs:{"headers":_vm.headers,"items":_vm.desserts,"items-per-page":5}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header mb-6"},[_c('h2',[_vm._v("Nueva table")])])
}]

export { render, staticRenderFns }